/**
 * Hook to get approvers for a product
 */
import useSWR from "swr";
import { endpoints } from "../../../../../endpoints";
import type { ProductApproversResponse } from "../../../../../types/types.Workflow";
import { useStoreState } from "../../../../../util/util";
import { fetcher } from "../../../../../util/util";
import { AxiosError } from "axios";

export function useProductApprovers(productId: string | null) {
  const { storefront_id } = useStoreState();

  const { data, error, mutate, isValidating } =
    useSWR<ProductApproversResponse>(
      storefront_id && productId
        ? endpoints.v2_storefronts_id_integrations_products_id_approvers(
            storefront_id,
            productId
          )
        : null,
      fetcher
    );

  return {
    approvers: data?.data,
    stageOrder: data?.stage_order,
    stageNames: data?.stage_names,
    error: error as AxiosError<{ message: string }>,
    isLoading: !data && !error && !!productId,
    isValidating,
    mutate,
  };
}
